import React from 'react';
type Option = {
  value: string;
  label: string;
};
type SelectProps = {
  label: string;
  id: string;
  name: string;
  options: Option[];
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  required?: boolean;
  error?: string;
  className?: string;
};
const Select = ({
  label,
  id,
  name,
  options,
  value,
  onChange,
  placeholder,
  required = false,
  error,
  className = ''
}: SelectProps) => {
  return <div className={`mb-4 ${className}`} data-id="element-415">
      <label htmlFor={id} className="block mb-2 font-medium text-dark" data-id="element-416">
        {label} {required && <span className="text-red-500" data-id="element-417">*</span>}
      </label>
      <select id={id} name={name} value={value} onChange={onChange} required={required} className={`w-full px-4 py-2.5 rounded-custom border ${error ? 'border-red-500' : 'border-border'} focus:outline-none focus:ring-2 focus:ring-primary/50`} data-id="element-418">
        {placeholder && <option value="" disabled data-id="element-419">
            {placeholder}
          </option>}
        {options.map(option => <option key={option.value} value={option.value} data-id="element-420">
            {option.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-421">{error}</p>}
    </div>;
};
export default Select;